// extracted by mini-css-extract-plugin
module.exports = {"image":"imageCarousel_image__dQp7w"};